// Executive Dashboard status vocabulary — single source of truth for the
// frontend. ACTIVE_PIPELINE_STATUSES (the "is this active at all" set) must
// match sp_GetExecutiveDashboard / sp_SyncDashboardStatuses's allowlist
// (db/82_estimate_milestones.sql / db/02_projects.sql) exactly — that part
// hasn't changed. The four groups below are purely a frontend bucketing
// concern (which section a status's row renders in); the SQL side doesn't
// need to know about them. src/test/executiveDashboardBuckets.test.js pins
// all of this so the SQL allowlist and the frontend groups can't silently
// drift apart.
//
// Regrouped 2026-09-21 (Ben, after finding "Qualification In Progress"
// rows sitting in "Active Estimating — Sales" — real data, just the wrong
// bucket): "Active Estimating" is a specific pipeline step, not a catch-all
// for "still un-shipped, not Sales Development, not Realignment" — every
// status now has exactly one clearly-named home.
export const SALES_DEVELOPMENT_STATUSES = ["Prospecting", "Qualified to Pursue", "Qualification In Progress"];
export const REALIGNMENT_STATUSES = ["Scope Alignment", "Descope / Value Engineering", "Commercial Alignment"];
export const PROPOSAL_ISSUED_STATUSES = ["Proposal Sent", "Waiting on PO", "Closed Won"];

export const ACTIVE_PIPELINE_STATUSES = [
  ...SALES_DEVELOPMENT_STATUSES,
  "Active Estimating",
  ...REALIGNMENT_STATUSES,
  ...PROPOSAL_ISSUED_STATUSES,
];

// Full "Sales Pipeline CleanSpace" stage list (verified live against HubSpot
// 2026-09-21), in pipeline order — includes the closed-out stages that
// ACTIVE_PIPELINE_STATUSES deliberately excludes. Used only for the sync-lock
// override's status picker: when an estimator corrects a stale HubSpot stage
// (e.g. HubSpot still says "Active Estimating" but the proposal shipped
// months ago and the deal has since closed), they need the full vocabulary,
// not just the active subset. CleanShield's pipeline uses different stage
// IDs for the same names — not modeled here, CleanShield is out of scope for
// this feature per 2026-09-21 product decision.
export const ALL_PIPELINE_STATUSES = [
  "Prospecting", "Qualification In Progress", "Qualified to Pursue",
  "Active Estimating", "Scope Alignment", "Descope / Value Engineering",
  "Commercial Alignment", "Waiting on PO",
  "Proposal Sent", "Closed Won", "On Hold", "Closed Lost", "No Bid",
];
